import { useMemo, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";

export const useUrlFilters = () => {
    const history = useHistory();
    const { pathname, search, state } = useLocation();

    const initialFilters = useMemo(() => {
        const params = new URLSearchParams(search);
        const columnFilters = [];
        let globalFilter = "";

        params.forEach((value, key) => {
            if (key === "g") {
                globalFilter = value;
            } else if (key.startsWith("f_")) {
                if (value.includes("|")) {
                    const [min, max] = value.split("|");
                    if (min == "" && max == "") return;

                    const parseVal = v => {
                        if (!v) return undefined;

                        else if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {// Check if it's a date string (YYYY-MM-DD)
                            return new Date(v + 'T00:00:00');
                        }
                        else if (!isNaN(v)) return Number(v); // numeric range
                        else return v;
                    };

                    columnFilters.push({
                        id: key.slice(2),
                        value: [parseVal(min), parseVal(max)],
                    });
                } else {
                    columnFilters.push({ id: key.slice(2), value });
                }
            }
        });

        return { columnFilters, globalFilter };
    }, []);


    const handleFiltersChange = useCallback(
        (columnFilters, globalFilter) => {
            const params = new URLSearchParams();
            const currentParams = new URLSearchParams(search);

            currentParams.forEach((value, key) => {
                if (key !== "g" && !key.startsWith("f_")) {
                    params.set(key, value);
                }
            });

            if (globalFilter) {
                params.set("g", globalFilter);
            }

            columnFilters.forEach((filter) => {
                if (filter.value) {

                    if (Array.isArray(filter.value)) {
                        const [min, max] = filter.value;

                        if (min == null && max == null) return;

                        const formatValue = (v) => {
                            if (v == null) return "";
                            if (v instanceof Date) return v.toISOString().split('T')[0];
                            return v;
                        };

                        params.set(
                            `f_${filter.id}`,
                            `${formatValue(min) ?? ""}|${formatValue(max) ?? ""}`
                        );
                    } else {
                        if (!String(filter.value).trim()) return;
                        params.set(`f_${filter.id}`, filter.value);
                    }
                }
            });

            const sortedParams = new URLSearchParams(
                Array.from(params.entries()).sort((a, b) => a[0].localeCompare(b[0]))
            );
            const newQueryString = sortedParams.toString();
            const currentQueryString = search.replace("?", "");

            if (newQueryString !== currentQueryString) {
                history.replace({ pathname, search: newQueryString ? `?${newQueryString}` : "", state: state });
            }
        },
        [history, pathname, search]
    );

    return { initialFilters, handleFiltersChange };
};
